enum LogoName {
  TommyHilfiger = 'TommyHilfiger',
  GuidoMaria = 'GuidoMaria',
  Lascana = 'Lascana',
  Hugo = 'Hugo',
}

export const filterLogoAssets: {[key in LogoName]: string} = {
  [LogoName.TommyHilfiger]: require('./x-tommy-hilfiger.svg'),
  [LogoName.GuidoMaria]: require('./x-kleiner-GMK.svg'),
  [LogoName.Lascana]: require('./x-lascana-logo-black.svg'),
  [LogoName.Hugo]: require('./x-hugo-logo.svg'),
};
